export default "__VITE_ASSET__rVA0o$Pq__"